module.exports = __webpack_public_path__ + "static/media/sky-platform.c61471c0.png";